var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card, Image } from '@philips-internal/oswald-ui-components/lib/components';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import './card-exam-establishment-information.css';
import { CardExamsEstablishmentInformationApi } from './card-exam-establishment-information-api';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { LanguageService } from '@philips-internal/oswald-ui-core/lib/services';
import { LocaleTypes } from '../../constants/locale-types';
let CardExamsEstablishmentInformation = class CardExamsEstablishmentInformation extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            visible: true,
            width: 12
        };
        this.onClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        ...this.props
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener,
    }; }
    defineDistrict(state, district) {
        const language = LanguageService.getCurrentLanguage();
        if (language == LocaleTypes.COLOMBIA && district) {
            return district;
        }
        return state;
    }
    render() {
        const { establishmentExam = {} } = this.props;
        const { dsEndereco, nrEndereco, dsEstado, dsDistrito, dsMunicipio, dsRazaoSocial, nrDdiTelefone = '', nrDddTelefone = '', nrTelefone = '' } = establishmentExam;
        const phoneNumber = `${nrDdiTelefone} ${nrDddTelefone} ${nrTelefone}`;
        const hasPhoneNumber = phoneNumber.trim().length > 0;
        const district = this.defineDistrict(dsEstado, dsDistrito);
        return (React.createElement(Card, { className: 'card-exam-establishment-information', onClick: () => this.onClick(), width: 12, selectionType: SelectionType.SINGLE, uuid: generateUUID() },
            React.createElement("div", { className: 'info-label' }, dsRazaoSocial),
            React.createElement("div", { className: "info-content" },
                React.createElement("div", { className: 'info' },
                    React.createElement("div", { className: 'icon' },
                        React.createElement(Image, { src: '/static/assets/icons/locale.svg', alt: '', className: 'icon-locale' })),
                    React.createElement("div", { className: 'local-info' }, `${dsEndereco}, ${nrEndereco} ${dsMunicipio}, ${district}`)),
                React.createElement("div", { className: 'info' }, hasPhoneNumber ?
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: 'icon' },
                            React.createElement(Image, { src: '/static/assets/icons/phone.png', alt: '', className: 'icon-phone' })),
                        React.createElement("div", { className: 'phone-info' }, phoneNumber))
                    : ''))));
    }
};
CardExamsEstablishmentInformation = __decorate([
    AwesomeComponent({ api: CardExamsEstablishmentInformationApi, type: ComponentType.DATA_DISPLAY })
], CardExamsEstablishmentInformation);
export default CardExamsEstablishmentInformation;
//# sourceMappingURL=card-exam-establishment-information.js.map